import _ from 'underscore';

const serializecsvRow = (imageInfo, aid) => {
  let url;
  let metadata;
  let baseId;
  let sourceType;

  if (_.isString(imageInfo)) {
    url = imageInfo;
  } else {
    ({
      url, metadata, baseId, sourceType,
    } = imageInfo);
  }

  // some image urls have commas, which will
  // interfere with bulk upsert operation
  const encodedUrl = url.replace(/,/g, encodeURIComponent(','));

  return `Image,Active,GenericImage,,,${aid},${encodedUrl},${baseId || ''},${metadata || ''},${sourceType || ''}`;
};

export const serializeCSV = (imageInfos, aid) => {
  if (_.isEmpty(imageInfos)) {
    return [];
  }

  const csvHeader = 'Type,Status,Sub Type,Id, Name,Parent Id,Url,Base id,Metadata,Source Type';
  const csvFormat = 'Format Version,,,,6,,,,';
  const csvRows = _.map(imageInfos, imageInfo => serializecsvRow(imageInfo, aid));
  const csv = _.flatten([csvHeader, csvFormat, csvRows]);

  return csv;
};


export const extractIds = (csvData) => {
  let errorColIndex = -1;
  let imageIdColIndex = -1;
  const headers = csvData[0];

  _.each(headers, (col, index) => {
    if (col === 'Id') {
      imageIdColIndex = index;
    }
    if (col === 'Error') {
      errorColIndex = index;
    }
  });

  if (imageIdColIndex < 0 && errorColIndex < 0) {
    return [];
  }

  const ids = [];
  // first line is header, second line is format version. needs to be skipped.
  const data = csvData.slice(2);
  _.each(data, (row) => {
    if (errorColIndex !== -1 && row[errorColIndex]) {
      ids.push({ code: row[errorColIndex] });
    } else if (imageIdColIndex !== -1) {
      ids.push(row[imageIdColIndex]);
    }
  });

  return ids;
};
